import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";
import { fetchSerialKillerById } from "../../api/serial-killers";
import type { SerialKillerDTO } from "@shared/contracts";
import type { Filter } from "../../context/VictimsAndKillersContext";
import { STALE_TIME } from "../../utils/constants";

export function useSerialKillerDetails(filters: Filter[]) {
  const ids = useMemo(
    () =>
      filters
        .filter((r) => r.type === "serialkiller" && !!r.killerId)
        .map((r) => r.killerId!) as string[],
    [filters]
  );

  const queries = useQueries({
    queries: ids.map((id) => ({
      queryKey: ["serialKillerById", id],
      staleTime: STALE_TIME,
      queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSerialKillerById(id, signal),
    })),
  });

  const serialKillerById = useMemo(() => {
    return Object.fromEntries(
      ids.map((id, i) => [id, queries[i]?.data as SerialKillerDTO | undefined])
    ) as Record<string, SerialKillerDTO | undefined>;
  }, [ids, queries]);

  const serialKillerLoadingById = useMemo(() => {
    return Object.fromEntries(ids.map((id, i) => [id, !!queries[i]?.isLoading])) as Record<
      string,
      boolean
    >;
  }, [ids, queries]);

  return { serialKillerById, serialKillerLoadingById };
}